import React from 'react';
import PriceChart from './PriceChart';

const CHARTS = [
  { symbol: 'AAPL', name: 'Apple Inc.', type: 'stock' as const },
  { symbol: 'RHM.DE', name: 'Rheinmetall AG', type: 'stock' as const },
  { symbol: 'SPX', name: 'S&P 500', type: 'index' as const },
  { symbol: 'DAX', name: 'DAX 40', type: 'index' as const },
  { symbol: 'A1ZCSB', name: 'Rabobank 6,50% perpetual', type: 'bond' as const },
  { symbol: 'A3L7AM', name: 'EPH Group 10% 2025/2032', type: 'bond' as const },
];

export default function ChartDashboard() {
  return (
    <div>
      {/* Section: Stocks */}
      <div style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#4A5068', marginBottom: '12px' }}>
          <span style={{ color: '#00D97E', marginRight: '6px' }}>●</span> Aktien
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          {CHARTS.filter(c => c.type === 'stock').map(c => (
            <PriceChart key={c.symbol} {...c} />
          ))}
        </div>
      </div>

      {/* Section: Indices */}
      <div style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#4A5068', marginBottom: '12px' }}>
          <span style={{ color: '#3B82F6', marginRight: '6px' }}>●</span> Indizes
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          {CHARTS.filter(c => c.type === 'index').map(c => (
            <PriceChart key={c.symbol} {...c} />
          ))}
        </div>
      </div>

      {/* Section: Bonds */}
      <div style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#4A5068', marginBottom: '12px' }}>
          <span style={{ color: '#FBBF24', marginRight: '6px' }}>●</span> Anleihen
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          {CHARTS.filter(c => c.type === 'bond').map(c => (
            <PriceChart key={c.symbol} {...c} defaultPeriod="MAX" />
          ))}
        </div>
      </div>
    </div>
  );
}
